import colors from './colors'

export default {
  title: 'Configuraciones del sitio',

  titles: {
    settings: 'Configuraciones del sitio',
    reseller: 'Configuraciones del sitio del revendedor',
    resellers: 'Revendedores',
    auth: 'Autorización',
    frontend: 'Apariencia',
    notifications: 'Notificaciones',
    payments: 'Pagos',
    globalBlacklistManager: 'Lista negra global',
    apisender: 'API Sender',
    integrations: 'Integraciones',
    misc: 'Varios',
    'otp-verification': 'Verificación OTP'
  },

  subtitles: {
    globalBlacklistManager: 'Configuraciones de listas',

    resellers: {
      domains: 'Dominios'
    },

    auth: {
      registration: {
        defaults: 'Valores predeterminados al registrarse'
      }
    },

    frontend: {
      title: 'Título del sitio',
      colors: 'Colores del sitio',
      documents: 'Documentos públicos',
      jivosite: 'Configuraciones de Jivosite'
    },

    payments: {
      methods: 'Configuraciones de métodos de pago'
    },

    apisender: {
      settings: {
        readChatSettings: 'Leer configuraciones del chat',
        sendMessageSettings: 'Configuraciones de envío de mensajes',
        webhookSettings: 'Configuraciones del webhook'
      }
    },

    integrations: {
      yclients: {
        applicationCredentials: 'Datos de conexión a YClients'
      }
    },

    notifications: {
      sms: 'Notificaciones SMS',
      extraRecipients: 'Destinatarios adicionales de notificaciones',

      email: {
        smtp: 'Conexión SMTP'
      },

      templates: {
        users: 'Plantillas para usuarios',
        managers: 'Plantillas para gerentes'
      },

      events: {
        providers: {
          health: {
            recipients: 'Destinatarios de notificaciones sobre el estado de los proveedores'
          }
        }
      }
    },

    misc: {
      rootId: 'Root ID'
    },

    'otp-verification': {
      'user-phone': 'Configuración del widget'
    }
  },

  labels: {
    reseller: 'Seleccionar revendedor',

    resellers: {
      domains: {
        domain: 'Dominio',
        user: 'Usuario'
      }
    },

    auth: {
      registration: {
        defaults: {
          allowDuplicates: 'Permitir duplicados de mensajes',
          sendernamesCheck: 'Restringir nombres de remitentes para tipos',
          patternsCheck: 'Verificación obligatoria por patrón de moderación para tipos',
          balance: 'Balance predeterminado',
          tariffs: 'Tarifa predeterminada',
          routingGroups: 'Grupo de enrutamiento',
          messageRuleGroups: 'Grupo de reglas de mensajes',
          sendernames: 'Nombres de remitentes',
          patterns: 'Patrones',
          currency: 'Moneda'
        }
      }
    },

    frontend: {
      title: 'Título del sitio',
      colors: colors.labels,
      jivosite: 'ID de Jivosite',

      documents: {
        privacyPolicy: 'Política de privacidad',
        publicOffer: 'Oferta pública'
      }
    },

    payments: {
      allowedGlobalMethods: 'Métodos de pago globales permitidos'
    },

    globalBlacklistManager: {
      mainListId: 'Lista principal',
      temporaryAvailableListId: 'Lista de números temporalmente permitidos'
    },

    integrations: {
      yclients: {
        applicationCredentials: {
          id: 'ID de la aplicación',
          token: 'Token de la aplicación'
        }
      }
    },

    notifications: {
      extraRecipients: 'Destinatarios',

      sms: {
        senderUserId: 'Remitente',
        sendername: 'Nombre del remitente'
      },

      email: {
        smtp: {
          host: 'Host',
          port: 'Puerto',
          from: 'Desde',
          login: 'Nombre de usuario',
          password: 'Contraseña'
        }
      },

      events: {
        providers: {
          health: {
            recipients: 'Destinatarios'
          }
        }
      }
    },

    misc: {
      rootId: 'UUID'
    },

    'otp-verification': {
      'user-phone': {
        widgetId: 'Widget',
        widgetToken: 'Token'
      }
    }
  },

  hints: {
    warning: 'Está editando las configuraciones del sitio del usuario seleccionado.',

    frontend: {
      colors: colors.hints,
      jivosite: 'Establezca un ID de Jivosite personal para activar el módulo de soporte en el sitio',

      documents: {
        privacyPolicy: 'Archivo que se ofrecerá a los usuarios para su revisión',
        publicOffer: 'Archivo que se ofrecerá a los usuarios para su revisión'
      }
    },

    notifications: {
      extraRecipients: 'Notificaciones sobre el estado del balance de todos los usuarios del sistema',

      email: {
        templates: {
          balance: {
            limit: 'Mensaje que se enviará al usuario al alcanzar uno de los valores límite del balance'
          },

          auth: {
            registration: 'Mensaje que se enviará al usuario al registrarse',
            recover: 'Mensaje que se enviará al usuario al intentar recuperar la contraseña'
          },

          manager: {
            balance: {
              limit: 'Mensaje que se enviará al gerente o administrador al alcanzar uno de los valores límite del balance de los usuarios secundarios'
            },

            providers: {
              health: 'Mensaje que se enviará si el proveedor se desconecta por alguna razón'
            }
          }
        }
      },

      sms: {
        templates: {
          otp: {
            generate: {
              sendernames: {
                moderation: 'Mensaje que se enviará al confirmar el número del remitente por SMS'
              }
            }
          }
        }
      },

      events: {
        balance: {
          limit: {
            title: 'La notificación se activará al alcanzar el balance de {amount}',
            onLimit: 'Al alcanzar el balance',
            noLimit: '<límite no especificado>',
            notifyBy: 'notificar por',
            noNotifications: '<no notificar>',
            activator: 'La notificación se activará al alcanzar el balance de {limit}',
            overdraft: ' + sobregiro del usuario',
            invoice: 'Adjuntar factura por {amount}'
          }
        }
      }
    },

    payments: {
      methods: 'Configure varios métodos de recarga de balance utilizando integraciones preestablecidas con sistemas de pago'
    }
  },

  misc: {
    globalSettings: 'Configuraciones globales'
  },

  snackbars: {
    updated: 'Configuración actualizada exitosamente.'
  },

  patterns: {
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    url: 'Url',
    domain: 'Dominio',
    title: 'Título',

    recipient: {
      username: 'Nombre de usuario',
      email: 'Correo electrónico',
      phone: 'Teléfono'
    }
  }
}
